import {Plan} from "../../../types";
import {ValidationMessage, MessageOpts} from "../../types";
import {ManholeCountValidationResult, validateManholeCount} from "../rules/manholeCountValidation";
import {LimitingReason} from "../../../containers/domain/getMaxAllowedManholeCount";

export const getManholeCountErrorMessages = (plan: Plan, opts: MessageOpts): ValidationMessage[] => {
    const {
        resolveLocation,
        resolveLocationText,
        severity = 'error',
    } = opts;
    const validationResult = validateManholeCount(plan);

    return validationResult.ok
        ? []
        : [{
            message: getMessage(validationResult),
            severity,
            resolveLocation,
            resolveLocationText,
        }]
}

const getMessage = (validationResult: ManholeCountValidationResult) => {
    const reasonString = getReasonString(validationResult.limitingReason)

    if (reasonString.length > 0) return reasonString;
    const maxCount = validationResult.maxManholeCount;

    if (maxCount === 0) return "Es sind keine Einstiegsöffnungen erlaubt"
    if (maxCount === 1) return "Es ist nur eine Einstiegsöffnung erlaubt"
    return `Die maximale erlaubte Anzahl an Einstiegsöffnungen von ${validationResult.maxManholeCount}`
        + ` wurde überschritten.`
}


const getReasonString = (reason: LimitingReason): string => {
    const reasonMap: Record<LimitingReason, string> = {
        none: "",
        subfloorLidType: "Bei Unterflur-Abdeckungen ist nur eine Einstiegsöffnung erlaubt.",
        beveledCollar: "Bei abgeschrägtem Betonsockel ist nur eine Einstiegsöffnung erlaubt.",
        withoutCollar: "Bei Abdeckungen ohne Betonsockel ist nur eine Einstiegsöffnung erlaubt.",
        multiRowManholes: "Bei mehrreihigen Einstiegsöffnungen ist nur eine Einstiegsöffnung erlaubt."
    };

    return reasonMap[reason];
};

export const getManholeCountErrorIds = (plan: Plan): string[] => {
    const validationResult = validateManholeCount(plan);

    return validationResult.manholeIds
}
